import { camelcaseKeys } from 'src/utils/camelize-keys';

import { PlanAssignment, WorkoutPlan } from './_types';

export function normalizePlanAssignment(assignment: any): PlanAssignment {
  return camelcaseKeys(assignment, { deep: true });
}

export function normalizeWorkoutPlan(workoutPlan: any): WorkoutPlan {
  return camelcaseKeys(workoutPlan, { deep: true });
}
